import { env } from 'utils/envManager'

export function referrerFromSameUrl(previousUrl: string) {
	const previousHref = new URL(previousUrl, env.NEXT_PUBLIC_CURRENT_ORIGIN).href
	return window.location.href === previousHref
}
